/**
 * LoadingScreen.js
 * 
 * Full-screen loading state with a pulsing gamepad.
 */

import React from "react";
import { motion } from "framer-motion";
import { Gamepad2 } from "lucide-react";

/**
 * @param {String} message  -   What's loading, e.g. 'Setting up the room'
 * @returns {JSX.Element}
 */
const LoadingScreen = ({ message = "Loading" }) => {
    return (
        <div className="min-h-screen w-full flex flex-col items-center justify-center gap-6 bg-black text-white">
            <motion.div
                animate={{ scale: [1, 1.12, 1], rotate: [0, -6, 6, 0] }}
                transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
                className="flex items-center justify-center w-24 h-24 rounded-3xl bg-yellow text-black"
            >
                <Gamepad2 className="w-12 h-12" strokeWidth={2} />
            </motion.div>
            <div className="flex items-center gap-1 text-xl text-zinc-300">
                {message}
                {[0, 1, 2].map((dot) => (
                    <motion.span
                        key={dot}
                        animate={{ opacity: [0.2, 1, 0.2] }}
                        transition={{ duration: 1.2, repeat: Infinity, delay: dot * 0.2 }}
                    >
                        .
                    </motion.span>
                ))}
            </div>
        </div>
    );
};

export default LoadingScreen;
